function AplikSoftverVTTIi(){
    return(
        <div>
            AplikSoftverVTTIi
        </div>
    );
};

export default AplikSoftverVTTIi;